export default __webpack_public_path__ + "static/media/ZIKOLAND.3ddb92f7.png";